import { Icons } from "assets/icons";
import { X } from "lucide-react";
import { Calendar } from "primereact/calendar";
import React from "react";

const TimePicker = ({
  value,
  onChange,
  disabled = false,
  error = null,
  showClear = true,
}) => {
  const { clock } = Icons || {};
  return (
    <>
      <div className="position-relative">
        <Calendar
          value={value}
          onChange={(e) => onChange(e.value)}
          timeOnly
          hourFormat="12"
          disabled={disabled}
          placeholder="00:00:00"
          className="w-100"
        />
        <div
          style={{
            position: "absolute",
            top: "25px",
            insetInlineEnd: 15,
            transform: "translateY(-50%)",
            display: "flex",
            gap: "5px",
            alignItems:"center"
          }}
        >
          <img
            src={clock}
            width={24}
            height={24}
            alt="clock"
            className="clock_icon"
          />
          {value && !disabled && (
            <X
              size={18}
              className="timepicker-clear c_p"
              onClick={() => onChange(null)}
              style={{
                color: "#dc3545",
              }}
            />
          )}
        </div>
        {error && <div className="text-danger">{error}</div>}
      </div>
    </>
  );
};

export default TimePicker;
